import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import NoteDetails from "./NoteDetails";
import "./VisionStartNode.css";

const VisionStartNode = () => {
  const navigate = useNavigate();
  const { planId } = useParams();

  const goSetup = () => navigate(`/dashboard/start/vision-setup/${planId}`);
  const goSkip = () => navigate(`/dashboard/year-plan/${planId}`);

  return (
    <div className="vsn-shell">
      <div className="vsn-content">
        <NoteDetails />
      </div>

      <div className="vsn-footer">
        <div className="vsn-footer-inner">
          <p className="vsn-footer-text">
            This Node lives inside a Vision: the bigger picture it's part of.
          </p>
          <div className="vsn-footer-actions">
            <button
              type="button"
              className="vsn-footer-secondary"
              onClick={goSkip}
            >
              Skip for now
            </button>
            <button
              type="button"
              className="vsn-footer-primary"
              onClick={goSetup}
            >
              Set up your Vision →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionStartNode;
